import { put, takeLatest } from 'redux-saga/effects';
import { forceReload as forceReloadUserList } from '~/components/containers/UserManagementContainer/reducer';
import callRequestSaga from '~/sagas/utils/request-saga';
import InviteUserConstants from '~/components/containers/InviteUserContainer/constants';
import UserManagementSubmenuConstants from '~/components/containers/UserManagementSubmenuContainer/constants';
import UserManagementAPI from '~/api/user-management-api';

export function* closeAndReloadList() {
  // Close invite user modal
  yield put({ type: InviteUserConstants.CLOSE_INVITE_USER_MODAL });

  // Force update on next page load of user/invite list
  yield put(forceReloadUserList());

  // Reload submenu
  yield put({
    type: UserManagementSubmenuConstants.GET_USER_MANAGEMENT_SUBMENU,
  });
}

export function* sendUserInvite({
  email,
  firstName,
  lastName,
  roles,
  accessGroupIds,
  recaptchaVerification,
}) {
  yield* callRequestSaga(
    UserManagementAPI.sendUserInvite,
    {
      request: InviteUserConstants.SEND_USER_INVITE_REQUEST,
      success: InviteUserConstants.SEND_USER_INVITE_REQUEST_SUCCESS,
      failure: InviteUserConstants.SEND_USER_INVITE_REQUEST_ERROR,
    },
    email,
    firstName,
    lastName,
    roles,
    accessGroupIds,
    recaptchaVerification
  );
}

export function* closeAndReloadListSaga() {
  yield takeLatest(
    InviteUserConstants.CLOSE_INVITE_USER_MODAL_AND_RELOAD_USER_LIST,
    closeAndReloadList
  );
}

export function* sendUserInviteSaga() {
  // @ts-ignore
  yield takeLatest(InviteUserConstants.SEND_USER_INVITE, sendUserInvite);
}

export default [closeAndReloadListSaga, sendUserInviteSaga];
